import Cookies from "js-cookie";

window.VGLocationCity = {
	city: 'Калуга',
	cities: App.cities,

	get: function () {
		const _this = this;
		const data = {
			city: {
				title: _this.city
			}
		};

		if (App.yaMAP !== false) {
			ymaps.ready(init);

			function init() {
				let geolocation = ymaps.geolocation;

				geolocation.get({
					provider: 'browser',
					mapStateAutoApply: true
				}).then(function (result) {
					const firstGeoObject = result.geoObjects.get(0);
					data.city.title = firstGeoObject.getLocalities().join('');

					_this.set(data, false);
				}, function (err) {
					console.log(err);

					geolocation.get({
						provider: 'yandex',
						mapStateAutoApply: true
					}).then(function (result) {
						const firstGeoObject = result.geoObjects.get(0);
						data.city.title = firstGeoObject.getLocalities().join('');

						_this.set(data, false);
					}, function (err) {
						console.log(err);
						_this.set(data, false);
					});
				});
			}
		} else {
			_this.set(data, false);
		}
	},

	set: function (data, isConfirm = true) {
		let _this = this,
			$location = $('[data-location="city"]');

		if ($location) {
			if (isConfirm) {
				$location.text(data.city.title);

				let params = {
					id: data.city.id,
					_token: App.csrf,
				};

				$.post('/cities/set', params, function (data) {
					if (data.reload) {
						location.reload();
					}
				});

				_this.isConfirm($location);
			} else {
				let isCityConfirm = $location.data('location-confirm');

				if (!isCityConfirm) {
					$location.text(data.city.title + '?');

					if (_this.cities.length) {
						let $locationConfirm = $('[data-location="confirm"]'),
							$locationNoCity = $('[data-location="no-city"]');

						let city = _this.cities.filter(function (item) {
							return item.title.toLowerCase() === data.city.title.toLowerCase();
						});
						city = city.length ? city[0] : null;

						if (city) {
							$locationConfirm.attr('disabled', false);
							$locationConfirm.attr('data-id', city.id);
							$locationConfirm.attr('data-city', city.title);
						} else {
							$locationConfirm.attr('disabled', true);
							$locationNoCity.show();
						}
					}
				}
			}
		}
	},

	isConfirm: function ($location) {
		$location.closest('.location-city').find('#location-city-confirm').removeClass('show');
		$location.closest('.location-city').find('#location-city-choice').addClass('show');

		let cityElement = $('[data-location="city"]');
		cityElement.attr('data-location-confirm', 'true');
	},

	modal: function () {
		// проверяем нужно ли запускать модалку
		let modalCityConfirm = Cookies.get('modalCityConfirm');
		if (!modalCityConfirm) {
			const modal = new bootstrap.Modal('#modal-city-confirm');
			modal.show();

			document.querySelector('[data-modal-location="change"]').onclick = function () {
				document.getElementById('location-modal-city-confirm').style.display = 'none';
				document.getElementById('location-modal-city').style.display = 'none';
				document.getElementById('location-modal-city-choice').classList.add('show');

				return false;
			};
		}
	}
}

function onReady() {
	/** при первом посещении запускаем модалку **/
	VGLocationCity.modal();

	/** Выбран ли город **/
	let $location = $('[data-location="city"]');
	if ($location) {
		let getCityConfirm = $location.data('location-title');
		if (!getCityConfirm) {
			VGLocationCity.get();
		}
	}

	/** Не наш город, меняем **/
	document.querySelector('[data-location="change"]').onclick = function () {
		document.getElementById('location-city-confirm').classList.remove('show');
		document.getElementById('location-city-choice').classList.add('show');

		return false;
	};

	/** Мы угадали, подтверждение города **/
	const locationConfirm = $('[data-location="confirm"]');
	if (locationConfirm) {
		locationConfirm.on('click', function (e) {
			let isModal = $(this).data('data-location-modal') || false,
				id = $(this).data('id'),
				title = $(this).data('city');

			Cookies.set('modalCityConfirm', 'yes', {});

			if (!isModal) {
				vgDropdown.close(e, $(this).closest('.vg-dropdown-content'));
			}

			VGLocationCity.set({
				city: {
					id: id,
					title: title,
				}
			}, true);
		});
	}

	/** Выбираем город из списка **/
	const locationListCities = document.querySelectorAll('[data-location="set"]');
	if (locationListCities.length) {
		for (let setCity of locationListCities) {
			setCity.onclick = function (e) {
				let title = this.dataset.title,
					id = this.dataset.id,
					isModal = this.dataset.locationModal;

				if (isModal) {
					Cookies.set('modalCityConfirm', 'yes', {});
				} else {
					vgDropdown.close(e, $(this).closest('.vg-dropdown-content'));
				}

				VGLocationCity.set({
					city: {
						title: title,
						id: id,
					}
				}, true);

				return false;
			};
		}
	}
}

document.addEventListener("DOMContentLoaded", onReady);